






























































































































































import store from '@/app/store';
import { useKeycloak } from '@/modules/auth/composables/keycloak';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { OrbitSpinner } from 'epic-spinners';
import { UserRoles } from '../constants';

export default defineComponent({
    name: 'Home',
    metaInfo: {
        title: 'Home',
    },
    components: { OrbitSpinner },
    setup(props, { root }) {
        const open = ref(false);
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const heroImage = require('@/app/assets/img/banner-front-page-1920.webp');
        const heroStyle = computed(() => ({
            backgroundImage: `url(${heroImage})`,
            backgroundColor: '#9b8ed0',
        }));
        const isLoggingIn = ref(false);

        const user = computed(() => store.state.auth.user);
        const isModelModerator = computed(() => store.getters.auth.hasRole(UserRoles.ModelModerator));

        const tab = computed(() => {
            if (!user.value?.organisationId && isModelModerator.value)
                return { name: 'model-manager', label: 'Data Models' };
            return { name: 'dashboard', label: 'Dashboard' };
        });

        const {
            isEnabled,
            register,
            login: keycloakLogin,
            logout: keycloakLogout,
            isAuthenticated: keycloakAuthenticated,
        } = useKeycloak();
        const isAuthenticated = computed(() => keycloakAuthenticated());

        const isKeycloakEnabled = isEnabled();

        const logout = async () => {
            (root as any).$toastr.removeByType('info');
            try {
                store.commit.auth.CLEAR_USER();
                store.commit.notificationEngine.CLEAR_NOTIFICATIONS();
                await keycloakLogout(process.env.VUE_APP_URL);
            } catch (e: any) {
                (root as any).$toastr.e(e.message, 'Logout failed');
            }
        };

        const login = async () => {
            isLoggingIn.value = true;
            try {
                await keycloakLogin();
            } catch (e: any) {
                (root as any).$toastr.e(e.message, 'Error');
            } finally {
                isLoggingIn.value = false;
            }
        };

        if (
            isEnabled() &&
            document.location.hash.length > 0 &&
            document.location.hash.match(/^#.*code=[a-zA-Z0-9]*/g)
        ) {
            root.$router.push({ name: 'home', hash: '' });
        }

        return { open, heroStyle, isAuthenticated, login, logout, isKeycloakEnabled, register, isLoggingIn, tab };
    },
});
